import React from 'react';
import { GetStaticProps } from 'next';

import styles from './styles.module.scss';

import { withLayoutAndSession } from '@utils/hocs';
import { PageWithProvidersAndLayout } from '@utils/types/nextApp';
import MetaHead from '@components/_shared/metaHead';
import ImageBackground from '@components/_shared/imageBackground';
import { getCollectionsByType } from '@api/collections/getCollectionsByType';
import { CollectionType } from '@utils/types/collections';
import ExpandableSection from '@components/_shared/expandableSection';
import Link from 'next/link';

type Props = {
  collections: CollectionType[];
};

const TITLE = 'Explore exquisite Rove properties ';
const DESCRIPTION =
  'Each property offers a unique retreat designed to elevate your travel experience. Revel in stunning settings, premium amenities, and unparalleled service.';

const LocationsSitemap: PageWithProvidersAndLayout<Props> = (props: Props) => {
  const { collections } = props;

  const [openSections, setOpenSections] = React.useState<string[]>([]);

  return (
    <>
      <MetaHead title={TITLE} description={DESCRIPTION} />

      <div className={styles.locationsSitemap}>
        <ImageBackground
          containerStyle={styles.hero}
          backgroundImageStyle={`
            url('/images/sitemap-bg.png')
          `}
        >
          <div className={styles.hero__wrapper}>
            <h1 className={styles.hero__title}>{TITLE}</h1>
            <h2 className={styles.hero__subtitle}>{DESCRIPTION}</h2>
          </div>
        </ImageBackground>

        <div className={styles.locationsSitemap__list}>
          {collections.map((collection) => (
            <ExpandableSection
              key={collection.name}
              title={collection.title}
              isOpen={openSections.includes(collection.name)}
              onClick={() => {
                setOpenSections((prev) =>
                  prev.includes(collection.name)
                    ? prev.filter((name) => name !== collection.name)
                    : [...prev, collection.name]
                );
              }}
              theme="dark"
              containerStyle={styles.locationsSitemap__item}
            >
              <div className={styles.locationsSitemap__links}>
                {collection.related_listings.map((listing) => (
                  <Link
                    href={`/listing/${listing.slug.current}`}
                    key={listing.guestyId}
                  >
                    <a className={styles.locationsSitemap__link}>
                      {listing.listingTitle}
                    </a>
                  </Link>
                ))}
              </div>
            </ExpandableSection>
          ))}
        </div>
      </div>
    </>
  );
};

export const getStaticProps: GetStaticProps<any> = async () => {
  const collections = await getCollectionsByType([
    'market',
    'activity',
    'stay_length',
  ]);

  return {
    props: {
      collections,
    },
    revalidate: 30,
  };
};

export default withLayoutAndSession(LocationsSitemap, {
  headerProps: { theme: 'dark' },
  footerProps: { theme: 'dark' },
});
